

































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Building as BuildingEnum, Expansion, Faction, isShip } from "@gaia-project/engine";
import { corners } from "../graphics/hex";
import { planetClass } from "../graphics/utils";
import Planet from "./Planet.vue";
import { shipLetter } from "../data/building";
import { isAcademy } from "@gaia-project/engine/src/enums";

@Component<Building>({
  components: {
    Planet,
  },
})
export default class Building extends Vue {
  @Prop()
  faction: Faction;

  @Prop({ default: false, type: Boolean })
  flat: boolean;

  @Prop()
  shipMoved: boolean;

  @Prop()
  building: BuildingEnum;

  @Prop({ default: false, type: Boolean })
  outline: boolean;

  @Prop({ default: false, type: Boolean })
  outlineWhite: boolean;

  get buildingId() {
    return isAcademy(this.building) ? "ac" : this.building;
  }

  // FLAT buildings
  get planetClass() {
    return planetClass(this.faction);
  }

  get hexCorners() {
    return corners()
      .map(({ x, y }) => `${x * 40},${y * 40}`)
      .join(" ");
  }

  get triangleCorners() {
    return [
      { x: -0.5, y: Math.sqrt(3) / 4 },
      { x: 0.5, y: Math.sqrt(3) / 4 },
      { x: 0, y: -Math.sqrt(3) / 4 },
    ]
      .map(({ x, y }) => `${x * 0.5},${y * 0.5}`)
      .join(" ");
  }

  get mine() {
    return this.building === BuildingEnum.Mine;
  }

  get tradingStation() {
    return this.building === BuildingEnum.TradingStation;
  }

  get planetaryInstitute() {
    return this.building === BuildingEnum.PlanetaryInstitute;
  }

  get lab() {
    return this.building === BuildingEnum.ResearchLab;
  }

  get academy() {
    return isAcademy(this.building);
  }

  get gaiaFormer() {
    return this.building === BuildingEnum.GaiaFormer;
  }

  get colony() {
    return this.building === BuildingEnum.Colony;
  }

  get spaceStation() {
    return this.building === BuildingEnum.SpaceStation;
  }

  get customsPost() {
    return this.building === BuildingEnum.CustomsPost;
  }

  get isShip() {
    return isShip(this.building);
  }

  get shipLetter() {
    return shipLetter(this.building);
  }
}
